<template>
    <v-container>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate
                                 size="64"></v-progress-circular>
        </v-overlay>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="primary">
                        <v-toolbar-title style="color: white;">
                            Tramitar pago
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon color="white">mdi-file-upload-outline</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-row class="ms-2">
                            <v-col cols="12" md="6" offset-md="3">
                                <v-card>
                                    <v-card-title>
                                        Reportes
                                    </v-card-title>
                                    <v-data-table :headers="headres2"
                                                  hide-default-footer
                                                  :items="selected">
                                    </v-data-table>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6" offset-md="3">
                                <v-list style="color: black !important;">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Tipo:</v-list-item-title>
                                            <v-list-item-subtitle style="color: black;"><h6>Honorarios</h6></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>

                            </v-col>
                        </v-row>

                        <v-row class="ms-2">
                            <v-col cols="12" md="6" offset-md="3" class="mt-2">
                                <label class="typo__label" style="color: black; text-align: center;">Fecha:</label>
                                <v-menu ref="menu1"
                                        v-model="menu1"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="dateFormatted"
                                                      outlined
                                                      readonly
                                                      v-bind="attrs"
                                                      @blur="date = parseDate(dateFormatted)"
                                                      v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date"
                                                   locale="es-mx"
                                                   :min="minfecha"
                                                   :max="maxfecha"
                                                   @input="menu1 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>

                        <v-row class="ms-2">
                            <v-col cols="12" md="6" offset-md="3">
                                <label class="typo__label" style="color: black; text-align: center;">Paquetería:</label>
                                <multiselect placeholder="Seleccione un valor" :options="cpaqueteria" v-model="paqueteria"
                                             label="pqnombre" track-by="pqclave" deselect-label="No se puede remover el valor seleccionado"
                                             selected-label="Seleccionado" select-label="Seleccionar valor" :class="colors" @input="addTag()">
                                </multiselect>
                                <span style="color: red;" v-show="validaMulti">Selección requerida</span>
                            </v-col>
                        </v-row>
                        <v-row v-if="valdd" class="ms-2">
                            <v-col cols="12" md="6" offset-md="3">
                                <v-form ref="frmguia" v-model="valid" lazy-validation>
                                    <label class="typo__label" style="color: black; text-align: center;">Guía:</label>
                                    <v-text-field v-model="guia" :rules="rules" outlined required :disabled="valguia" :counter="25"></v-text-field>
                                </v-form>
                            </v-col>
                        </v-row>
                        <v-row class="ms-2">
                            <v-col cols="12" md="6" offset-md="3">
                                <v-form ref="frm" v-model="valid" lazy-validation>
                                    <span style="color: black; text-align: center;">Observaciones:</span>
                                    <v-textarea :counter="500"
                                                :rules="rulestextarea"
                                                outlined
                                                v-model="comentarios"
                                                required
                                                name="input-7-4"></v-textarea>
                                </v-form>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-btn class="ma-2"
                                       color="primary"
                                       @click="Guardar()">
                                    Guardar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn class="ma-2" @click="Limpiar()">
                                    Limpiar
                                </v-btn>
                                <v-btn class="ma-2" @click="Regresar()" color="error">
                                    Regresar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import Reporte from '@/services/TramitePago/TramitePago.Service.js';
    import moment from "moment";

    export default {
        title() {
            return this.$route.meta.title
        },
        data: vm => ({
            colors: '',
            valid: true,
            validaMulti: false,
            minfecha: null,
            maxfecha: new Date().toISOString(),
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
            menu1: false,
            continuar: true,
            envio: false,
            show: true,
            headres2: [
                { text: 'Reporte', value: 'nrreporte', class: "text title" },
                { text: 'Asistencia', value: 'Asistencia', class: "text title" },
                { text: 'Cliente', value: 'Cliente', class: 'text title' },
                { text: 'Fecha del Reportes', value: 'svfhreporte', class: "text title" },
            ],
            comentarios: '',
            cpaqueteria: [],
            paqueteria: '',
            guia: '',
            valguia: true,
            rules: [
                v => !!v || 'Campo requerido.',
                v => {
                    if (v == null)
                        return true
                    else {
                        if (v.length < 12)
                            return 'Mínimo de 12 carácteres';
                        else if (v.length > 25)
                            return 'Máximo 25 carácteres';
                        else
                            return true;
                    }
                }
            ],
            rulestextarea: [
                v => !!v || 'Campo requerido',
                v => {
                    if (v == null) {
                        return true
                    }
                    else {
                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > 500) {
                            return 'Máximo 500 Carácteres'
                        }
                        else
                            return true
                    }
                },
            ],
            validguar: false,
            valdd: false,
            valg: false,
            overlay: false,
        }),
        props: ['selected'],
        watch: {
            date(val) {
                this.dateFormatted = this.formatDate(this.date)
            },
            overlay(val) {
                val && setTimeout(() => {
                    this.overlay = false
                }, 2000)
            },
        },
        computed: {
            ...mapState([
                "domain",
                "informationPage",
                "paginacion",
                "permission",
                "user"
            ]),
            computedDateFormatted() {
                return this.formatDate(this.date)
            },
        },
        methods: {
            CatalogoPaqueteria() {
                Reporte.CatalogoPaqueteria(this).then(data => {
                    if (!data[0].hasOwnProperty('success')) {
                        this.cpaqueteria = data;
                    }
                    else {
                        console.log(data[0]);
                    }
                });
            },
            formatDate(date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate(date) {
                if (!date) return null

                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            addTag() {
                if (this.paqueteria !== "" && this.paqueteria !== null) {
                    this.colors = '';
                    
                    if (this.paqueteria.pqclave != 8) {
                        this.valdd = true;
                        this.valguia = false;
                        this.validaMulti = false;
                    }
                    else {
                        this.valdd = false;
                        this.validaMulti = false;
                        this.valguia = true;
                    }
                }
                else {
                    this.valguia = true;
                    this.valdd = false;
                    this.validaMulti = true;
                }
            },
            Guardar() {
                if (this.selected === undefined) {
                    this.$swal({
                        position: 'center',
                        icon: 'info',
                        title: 'Debe seleccionar al menos un reporte para su Trámite',
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar',
                        timer: 2000,
                    }).then(() => {
                        this.$router.push({ name: `ReportesAbogado` });
                    });
                }
                else {
                    if (this.paqueteria === "" || this.paqueteria === null) {
                        this.colors = 'border: 1px solid red;';
                        this.validaMulti = true;
                    }
                    else
                        this.validaMulti = false;


                    if (this.valdd) {
                        this.valg = this.$refs.frmguia.validate();
                    }
                    else
                        this.valg = true;
                    if (this.comentarios != '') {
                        this.comentarios = this.comentarios.trim();
                        this.comentarios = this.comentarios.replace(/\s*$/, "");
                    }
                    if (this.guia.length != '') {
                        this.guia = this.guia.trim();
                        this.guia = this.guia.replace(/\s*$/, "");
                    }
                    if (this.$refs.frm.validate() && this.comentarios.length >= 12 && this.validaMulti == false && this.valg ) {
                        
                        var reportes = '';
                        this.selected.forEach(function (data) {
                                reportes += data.nrreporte + '/';
                        });
                        var formData = new FormData();
                        formData.append("paqueteria", this.paqueteria == null ? '' : this.paqueteria.pqclave);
                        formData.append("guia", this.guia);
                        formData.append("fecha", this.date);
                        formData.append("observacion", this.comentarios);
                        formData.append("reportes", reportes);
                        this.$swal({
                            title: "Cargando, espere un momento...",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                        this.$swal.showLoading();
                        Reporte.InsertaEnvioPago(this, formData).then(data => {
                            
                            if (data) {
                                this.$swal({
                                    position: "center",
                                    icon: "success",
                                    title: "Éxito",
                                    text: "Se guardo correctamente",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    showConfirmButton: true,
                                    timer: 2000,
                                    confirmButtonText: "Ok!",
                                }).then(() => {
                                    this.$router.push({ name: `ReportesAbogado` });
                                });
                            }
                            else {
                                this.$swal({
                                    position: "center",
                                    icon: "error",
                                    title: "Error",
                                    text: "No se pudo guardar los datos, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    showConfirmButton: true,
                                    confirmButtonText: "Ok!",
                                });
                            }

                        });
                    }
                }

            },
            clearTabla() {
                this.selected = [];

            },
            Limpiar() {
                this.$refs.frm.reset();
                this.paqueteria = null;
                this.guia = '';
                this.valdd = false;
                this.validaMulti = false;
                this.comentarios = '';
                this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            },
            Regresar() {
                this.$router.push({ name: `ReportesAbogado` });

            }
        },
        mounted() {
            //this.minfecha.setDate(new Date().getDate() - 3);

            console.log(moment().add(-3, 'd').format("YYYY[-]MM[-]DD"));
            if (this.selected == undefined)
                this.Regresar();
            this.CatalogoPaqueteria();
            this.overlay = true;
        }
    }
</script>
<style>
    .multiselect--active {
        z-index: 9999 !important;
    }

    .border-error {
        border-color: red;
    }
</style>